module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "describe"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("广西田阳新靖田农产品贸易有限公司")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "chart"
  }, [_c('div', [_c('p', {
    staticClass: "tit"
  }, [_vm._v("带动贫困户电商产品")]), _vm._v(" "), _c('v-two-bar')], 1), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "tit"
  }, [_vm._v("带动贫困户")]), _vm._v(" "), _c('v-line')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "list-item"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("510吨")]), _vm._v(" "), _c('p', {
    staticClass: "word"
  }, [_vm._v("带动贫困户电商产品产量")])]), _vm._v(" "), _c('div', {
    staticClass: "list-item"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("2585305")]), _vm._v(" "), _c('p', {
    staticClass: "word"
  }, [_vm._v("帮扶总额(元)")])]), _vm._v(" "), _c('div', {
    staticClass: "list-item"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("184")]), _vm._v(" "), _c('p', {
    staticClass: "word"
  }, [_vm._v("带动贫困户数(户)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c0843a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpPoor/center/centerMiddle/index.vue
// module id = 1969
// module chunks = 2